import React from "react";
import Pills from "modules/Common/Components/Pills";
import styled from "styled-components";
import store from "store";
import { EMAIL_LIST } from "constants/types";

function EmailTabs(props: any) {
  const { tabState, setTabState } = props;
  const tabs = [
    { tab: "all", title: "All", className: "left-border" },
    { tab: "sent", title: "Sent", className: "middle-border" },
    { tab: "scheduled", title: "Scheduled", className: "middle-border" },
    { tab: "test", title: "Test", className: "right-border" },
  ];

  return (
    <Wrapper>
      {tabs.map((tab) => {
        return (
          <li onClick={() => setTabState(tab.tab)}>
            <Pills title={tab.title} active={tabState === tab.tab} className={tab.className} />
          </li>
        );
      })}
    </Wrapper>
  );
}

export default EmailTabs;

const Wrapper = styled.ul`
  display: flex;
  list-style: none !important;
  li {
    list-style-type: none;
  }
  .left-border {
    .wrapper {
      border-radius: 6px 0 0 6px !important;
    }
  }
  .right-border {
    .wrapper {
      border-radius: 0px 6px 6px 0px !important;
    }
  }
  .middle-border {
    .wrapper {
      border-radius: 0px 0px 0px 0px !important;
    }
  }
`;
